export enum DashboardTypeEnum {
  TOTAL_ORDERS = "TOTAL_ORDERS",
  TOTAL_SALES = "TOTAL_SALES",
}
